// extracted by mini-css-extract-plugin
module.exports = {"base":"SignUpForPremiumBanner_base__zgLIx"};